import { TradeInvestment, formatValue } from "../../../component/Methods";

export function buildTopMoversFilterLabel({
  fundVal,
  strategyVal,
  side = "Both",
} = {}) {
  const fund =
    !fundVal || fundVal === "ALL" ? "All funds" : String(fundVal).toUpperCase();
  const strategy =
    !strategyVal || strategyVal === "ALL"
      ? "All strategies"
      : String(strategyVal);
  const sideLabel =
    side === "Long" ? "Long only" : side === "Short" ? "Short only" : "Long & short";
  return `${fund} · ${strategy} · ${sideLabel}`;
}

/** Rank filtered table positions by today's (daily) dollar P/L. */
export function getTopMovers(positions = [], { count = 5 } = {}) {
  const ranked = positions
    .filter((item) => {
      const raw = item?.pL;
      if (raw === undefined || raw === null || Number.isNaN(Number(raw))) {
        return false;
      }
      const investment = item?.tickerInvestment;
      return (
        investment === TradeInvestment.Equity ||
        investment === TradeInvestment.Options
      );
    })
    .map((item) => {
      const shareCount = Number(item?.deltaAdjustedShareCount);
      return {
        ticker: String(item?.tickerSymbol ?? "")
          .split(" ")[0]
          .toUpperCase(),
        side: shareCount >= 0 ? "Long" : "Short",
        pl: Number(item.pL),
      };
    })
    .filter((item) => item.ticker);

  const sorted = [...ranked].sort((a, b) => b.pl - a.pl);

  return {
    gainers: sorted.slice(0, count),
    losers: sorted.slice(-count).reverse(),
    totalEligible: ranked.length,
  };
}

export function formatMoverPl(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  if (num >= 0) return formatValue(num);
  return `(${formatValue(Math.abs(num))})`;
}
